import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=124f7718&scoped=true&"
import script from "./IconUser.vue?vue&type=script&lang=ts&"
export * from "./IconUser.vue?vue&type=script&lang=ts&"
import style0 from "./IconUser.vue?vue&type=style&index=0&id=124f7718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f7718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
